import React from 'react';
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  VStack,
  HStack,
  Badge,
  IconButton,
  SimpleGrid,
  Divider,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import {
  AddIcon,
  DeleteIcon,
  EditIcon,
  CheckCircleIcon,
  ViewIcon,
  InfoOutlineIcon,
} from '@chakra-ui/icons';

const PlanList = ({
  data,
  handleEdit,
  handleDelete,
  viewDetails,
  setShowForm,
}) => {
  const bg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.600', 'gray.400');
  const emptyIconColor = useColorModeValue('teal.100', 'teal.900');

  if (!data || data.length === 0) {
    return (
      <Flex
        direction="column"
        align="center"
        justify="center"
        minH="400px"
        bg={bg}
        borderRadius="3xl"
        boxShadow="sm"
        p={10}
      >
        <Icon
          as={InfoOutlineIcon}
          w={20}
          h={20}
          color={emptyIconColor}
          mb={4}
        />
        <Heading size="md" color={textColor} mb={2}>
          No Plans Found
        </Heading>
        <Text color="gray.400" mb={6} textAlign="center">
          You haven't created any service plans yet. <br /> Create a plan to
          start selling through the mobile app.
        </Text>
        <Button
          colorScheme="teal"
          variant="outline"
          leftIcon={<AddIcon />}
          onClick={() => setShowForm(true)}
        >
          Add Your First Plan
        </Button>
      </Flex>
    );
  }

  return (
    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
      {data.map((plan) => (
        <Box
          key={plan._id}
          role="group"
          transition="all 0.3s ease-in-out"
          _hover={{ transform: 'translateY(-8px)', boxShadow: '2xl' }}
          bg={bg}
          borderRadius="2xl"
          overflow="hidden"
          boxShadow="0 10px 20px rgba(0,0,0,0.05)"
        >
          <Box h="5px" bg="teal.400" />
          <Box p={6}>
            <Flex justify="space-between" align="center" mb={4}>
              <Badge colorScheme="teal" borderRadius="full" px={3}>
                {plan.name}
              </Badge>
              <HStack spacing={1}>
                <IconButton
                  size="sm"
                  variant="ghost"
                  icon={<EditIcon />}
                  colorScheme="blue"
                  onClick={() => handleEdit(plan)}
                />
                {/* <IconButton
                  size="sm"
                  variant="ghost"
                  icon={<DeleteIcon />}
                  colorScheme="red"
                  onClick={() => handleDelete(plan._id)}
                /> */}
              </HStack>
            </Flex>

            <VStack align="left" minH="120px" spacing={3}>
              <HStack color="green.500" fontSize="xs" fontWeight="bold">
                <CheckCircleIcon />
                <Text>LIVE</Text>
              </HStack>
              <Box
                fontSize="sm"
                color="gray.600"
                noOfLines={3}
                dangerouslySetInnerHTML={{ __html: plan.details }}
              />
            </VStack>

            <Divider my={4} />
            <Button
              leftIcon={<ViewIcon />}
              w="full"
              variant="solid"
              colorScheme="teal"
              borderRadius="xl"
              onClick={() => viewDetails(plan)}
            >
              View Plan Details
            </Button>
          </Box>
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default PlanList;
